import React from "react";
import "./AboutHeroSection.css";
import { Heading } from "@tennr/frontend/components/Heading";
import { Fractals } from "@tennr/frontend/components/Fractals";

export interface AboutHeroSectionProps {
  className?: string;
}

export const AboutHeroSection: React.FC<AboutHeroSectionProps> = ({ className = "" }) => {
  return (
    <section className={`about-hero-section ${className}`}>
      <Fractals variant="about" className="about-hero-fractals" />
      <Heading
        title="GET TO KNOW US"
        heading={"The team\nbehind Tennr"}
        position="left"
        variant="xl"
        body={
          "Our founders met at Stanford working on advanced AI and LLM research. Now that foundation powers a system that processes over 10m documents per month."
        }
        className="about-hero-heading-content"
        width={523}
      />
    </section>
  );
};
